import { render, staticRenderFns } from "./VPrescriptionList.vue?vue&type=template&id=a4b6dccc&"
import script from "./VPrescriptionList.vue?vue&type=script&lang=ts&"
export * from "./VPrescriptionList.vue?vue&type=script&lang=ts&"
import style0 from "./VPrescriptionList.vue?vue&type=style&index=0&id=a4b6dccc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports